import React from "react";

export function PageHeader({ icon: Icon, title, subtitle, right }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3 mb-8">
      <div className="flex items-start gap-3 min-w-0">
        {Icon && (
          <div className="w-10 h-10 mt-1 shrink-0 rounded border border-blue-400/40 bg-blue-400/5 flex items-center justify-center">
            <Icon className="w-5 h-5 text-blue-400" />
          </div>
        )}
        <div className="border-l-2 border-blue-400/40 pl-4 -ml-1 min-w-0">
          <div className="ot-label mb-1">// {title}</div>
          <h1 className="ot-heading text-4xl sm:text-5xl font-black uppercase tracking-tighter text-slate-100 leading-none">
            {title}
          </h1>
          {subtitle && <div className="text-slate-400 mt-2 text-sm">{subtitle}</div>}
        </div>
      </div>
      {right}
    </div>
  );
}
